<app-loading [isLoading]="isLoading()" [message]="loadingMsg()" [overlayOpacity]="0"></app-loading>

@if (!isLoading()) {
<div class="mx-5">
  <kendo-breadcrumb [items]="breadcrumbs()" (itemClick)="onBreadcrumbClick($event)"></kendo-breadcrumb>
  <br />
  <div #entireRoadmap class="roadmap-container mat-elevation-z6">
    <p class="status p-2 m" [class.status-draft]="roadmap()?.status?.name == 'Draft'"
      [class.status-submitted]="roadmap()?.status?.name == 'Submitted'"
      [class.status-returned]="roadmap()?.status?.name == 'Returned'"
      [class.status-final]="roadmap()?.status?.name == 'Final'"
      [class.status-needsreview]="roadmap()?.status?.name == 'Needs Review'"
      [class.status-archived]="roadmap()?.status?.name == 'Archived'"
      [class.status-dryrun]="roadmap()?.status?.name == 'Dry Run'">
      {{(roadmap()?.status?.name == 'Final') ? 'APPROVED' : roadmap()?.status?.name?.toUpperCase()}}
    </p>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          @if(!roadmap()?.opportunityId) {
          <h2>Lean Roadmap - <i class="fas fa-unlink" style="color:red"></i><a style="color:red">Not Linked to Project</a></h2>
          <p style="max-width:600px; font-size:13px">
            This roadmap has not yet been linked to a project. You can edit and link it manually by editing the roadmap.
          </p>
          }
        </div>
        @if(roadmap()?.opportunityId) {
        <h2>Lean Roadmap - <fa-icon style="color:green" [icon]="faLink"></fa-icon><a style="color:green"> Linked to
            Project</a></h2>
        <p style="font-size:13px">This roadmap has been linked to <b>{{roadmap()?.officialProjectName}}
            (#{{roadmap()?.projectNumber}})</b></p>
        }
        <br>
        @if (!inEditMode()) {
          <h3>{{roadmap()?.projectName}} ({{roadmap()?.projectNumber}})</h3>
          <mat-chip-set class="py-2">
            <mat-chip class="version-chip">Version: {{roadmap()?.version}}</mat-chip>
          </mat-chip-set>
          <br>
          @if (roadmap()!.version! > 1) {
          <div class="px-2">
            <mat-slider matTooltip="Drag the slider back to view a previous version of this roadmap."
              matTooltipPosition="right" matTooltipShowDelay="150" [max]="roadmap()!.maxVersion" [min]="1" [step]="1"
              [discrete]="true" [showTickMarks]="true" style="width:300px;">
              <input matSliderThumb [(ngModel)]="versionSliderValue" #slider (change)="onVersionChange()">
            </mat-slider>
          </div>
          }
          <h4>
            <span>
              Roadmap Status: {{roadmap()!.status.name}}&nbsp;
            </span>
            @switch (roadmap()!.status.id) {
            @case (1) {
            <fa-icon style="color:dimgrey;font-size:20px" [icon]="faDraftingCompass" matTooltip="Draft, not submitted"
              matTooltipPosition="right" matTooltipShowDelay="150"></fa-icon>
            }
            @case (2) {
            <fa-icon style="color:steelblue;font-size:20px" [icon]="faAngleDoubleRight"
              matTooltip="Submitted for approval" matTooltipPosition="right" matTooltipShowDelay="150"></fa-icon>
            }
            @case (3) {
            <fa-icon style="color:red;font-size:20px" [icon]="faAngleDoubleLeft" matTooltip="Returned, revision needed"
              matTooltipPosition="right" matTooltipShowDelay="150"></fa-icon>
            }
            @case (4) {
            <fa-icon style="color:green;font-size:20px" [icon]="faUserCheck" matTooltip="Final, approved"
              matTooltipPosition="right" matTooltipShowDelay="150"></fa-icon>
            }
            @case (5) {
            <fa-icon style="color:yellowgreen;font-size:20px" [icon]="faExclamationCircle" matTooltip="Needs Review"
              matTooltipPosition="right" matTooltipShowDelay="150"></fa-icon>
            }
            @case (6) {
            <fa-icon style="color:gray;font-size:20px" [icon]="faFileAlt" matTooltip="Archived, historical record"
              matTooltipPosition="right" matTooltipShowDelay="150"></fa-icon>
            }
            @case (0) {
            <fa-icon style="color:#000000;font-size:20px" [icon]="faHistory" matTooltip="Dry Run, internal use only"
              matTooltipPosition="right" matTooltipShowDelay="150"></fa-icon>
            }
            }
          </h4>
          <br>
        } @else {
          <div class="d-flex flex-column">
            <div class="p-2 d-flex align-items-center">
              <mat-form-field style="width: 500px;margin-right: 10px;">
                <mat-label>Project Name</mat-label>
                <input autocomplete="off" matInput placeholder="What's the name of the project?" [(ngModel)]="projectName" required [disabled]="roadmap()!.opportunityId!.length > 0" maxlength="300" />
              </mat-form-field>
              <button matButton="filled" matTooltip="Link Roadmap with Project" matTooltipPosition="right" matTooltipShowDelay="150" (click)="onSearchClick()">
                <fa-icon [icon]="faSearch"></fa-icon> Search for projects to link
              </button>
            </div>
            <div class="p-2">
              <mat-form-field>
                <input autocomplete="off" matInput placeholder="Job Number" [(ngModel)]="projectNumber" required [disabled]="isProjectNumberTbd() || roadmap()!.opportunityId!.length > 0" maxlength="25" />
              </mat-form-field>
              <mat-checkbox style="padding-left:20px;" [(ngModel)]="isProjectNumberTbd" (change)="onProjectTbdChange($event.checked)"
                matTooltip="Select if you do not have a job number yet (To be decided)" matTooltipPosition="right" [disabled]="roadmap()!.opportunityId!.length > 0"
                matTooltipShowDelay="150">No job # (TBD)
              </mat-checkbox>
            </div>
            <div class="p-2">
              <mat-form-field style="width: 300px;">
                <mat-label>Roadmap Champion</mat-label>
                <input autocomplete="off" matInput placeholder="Who's the Roadmap Champion?" [(ngModel)]="leanChampionName" maxlength="100">
              </mat-form-field>
            </div>
            <div class="p-2">
              <mat-form-field style="width: 300px;">
                <mat-label>Select Approver</mat-label>
                <mat-select [disabled]="showFatalErrorApprover()" required [(ngModel)]="selectedApprover">
                  @for(approver of approvers(); track approver.graphId) {
                    <mat-option [value]="approver" matTooltip="{{approver.email}}" matTooltipPosition="left" matTooltipShowDelay="150">
                      {{approver.name}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            @if (showFatalErrorApprover()) {
            <p class="d-inline-flex" style="color:red;font-size:14px;">Error: Region has no Approvers designated. Please
              submit a service desk ticket if you continue to see this error.</p>
            }
          </div>
        }
      </div>
      <div class="row p-3">
        <div class="col-md-6">
          @if (roadmap()?.marketSegment) {
          <p><b>Market Segment:</b> {{roadmap()?.marketSegment}}</p>
          }
          @else {
          <p><b>Market Segment:</b> Not Available</p>
          }
          @if (roadmap()?.profitCenter?.profitCenterName) {
          <p><b>Profit Center:</b> {{roadmap()?.profitCenter?.profitCenterName}}</p>
          }
          @else {
          <p><b>Profit Center:</b> Not Available</p>
          }
          @if (roadmap()?.percentComplete != null) {
          <p><b>Percent Complete:</b> {{roadmap()?.percentComplete}}%</p>
          }
          @else {
          <p><b>Percent Complete:</b> Not Available</p>
          }
          @if (roadmap()?.isConfidential == true) {
          <p><b>Volume:</b> CONFIDENTIAL</p>
          }
          @else {
          <p><b>Volume:</b> ${{roadmap()?.revenue | number}}</p>
          }
          @if (roadmap()?.leanChampionName) {
          <p><b>Roadmap Champion(s):</b> {{roadmap()?.leanChampionName}}</p>
          }
          @else {
          <p><b>Roadmap Champion(s):</b> None Specified</p>
          }
        </div>
        <div class="col-md-6">
          @if (roadmap()?.approver) {
          <p><b>Selected Approver:</b> {{roadmap()!.approver!.name}}</p>
          } @else {
          <p><b>Selected Approver:</b> Not available, please update.</p>
          }
          @if (roadmap()?.createdBy) {
          <p><b>Created By:</b> {{roadmap()?.createdBy}}, on {{roadmap()?.createdOn | date: "mediumDate"}}</p>
          }
          @else {
          <p><b>Created By:</b> Not Available</p>
          }
          @if (roadmap()?.approvedBy) {
          <p><b>Approved By:</b> {{roadmap()?.approvedBy}}, on {{roadmap()?.approvedOn | date: 'mediumDate'}}
          </p>
          }
          @else {
          <p><b>Approved By:</b> Not approved</p>
          }
          @if (roadmap()?.lastModifiedOn) {
          <p><b>Last Edited:</b> {{roadmap()?.lastModifiedBy}}, on {{roadmap()?.lastModifiedOn | date: "mediumDate"}}
          </p>
          }
          @else {
          <p><b>Last Edited:</b> Not Available</p>
          }
        </div>
      </div>
    </div>
    <br />
    <div class="container-fluid">
      <div class="row">
        <div class="col-5">
          <kendo-chart #chartRef  [style.height.px]="280" class="compact-chart">
            <kendo-chart-tooltip>
              <ng-template kendoChartSeriesTooltipTemplate let-value="value" let-category="category">
                {{ category }}: {{ value }}
              </ng-template>
            </kendo-chart-tooltip>
            <kendo-chart-series>
              <kendo-chart-series-item type="pie" [data]="chartData()" categoryField="category" field="value"
                colorField="color" [padding]="0">
              </kendo-chart-series-item>
            </kendo-chart-series>
            <kendo-chart-legend [visible]="true" [position]="'top'" [margin]="0"></kendo-chart-legend>
          </kendo-chart>
        </div>
        <div class="col-7 text-end">
          <roadmap-controls [roadmapStatus]="roadmap()?.status" [inEditMode]="inEditMode()" [appUser]="appUser()!" [regionCheck]="true"
            [roadmapError]="showFatalErrorApprover()" (controlFunction)="roadmapSubmitControlFunction($event)">
          </roadmap-controls>
        </div>
      </div>
    </div>
    <br />
    @if (volumeOver10M()) {
    <p style="padding-top:5px; font-style: italic;">
      <span class="align-self-center" style="color:red; font-size:22px"
        matTooltip="Goals with this icon are required due to the project's volume." matTooltipPosition="right"
        matTooltipShowDelay="150">*
      </span>
      There are required goals because the estimated volume is greater than $10M. <span class="mobile-col-hide-xs">You
        can save a draft but
        can't submit the final roadmap until these goals are selected.</span>
    </p>
    <br />
    }
  </div>
  <div>
    <roadmap-goals [roadmap]="roadmap()" [volumeOver10M]="roadmap()!.revenue > 10000000" [isEditable]="inEditMode()"
      [currentConditions]="currentConditions()" [appUser]="appUser()" (pdfAction)="handlePdfAction($event)"></roadmap-goals>
  </div>

</div>
}
